if(!global["bf"]) global["bf"] = {};
module.exports = global["bf"]["gallery"] = require("-!/builds/360psg/blank/savannah/node_modules/babel-loader/lib/index.js??ref--0!./index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?bf.gallery!./src/frontend/gallery/index.js-exposed
// module id = 291
// module chunks = 5